import React from "react";
import {
  Send28Filled,
  Stop24Filled,
  CalligraphyPen20Regular,
  BotSparkle20Filled,
  LightbulbFilament20Regular,
  Code20Regular,
  ArrowSwap20Regular,
  TextDescription20Regular,
  PersonEdit20Regular, // Ideal for custom/individual modes
  Sparkle20Regular,
} from "@fluentui/react-icons";

type IconMapping = {
  [key: string]: React.ElementType;
};

// Mapping Object - Strings must match the 'icon' property in your AnswerMode objects
const iconMapping: IconMapping = {
  Sparkle20Regular: Sparkle20Regular, // Standard
  Code20Regular: Code20Regular, // Coding
  ArrowSwap20Regular: ArrowSwap20Regular, // Compare
  TextDescription20Regular: TextDescription20Regular, // Summary
  EditPerson20Regular: PersonEdit20Regular, // Custom / Individual Modes

  // UI Helpers
  Send28Filled: Send28Filled,
  Stop24Filled: Stop24Filled,

  // Legacy / Others
  CalligraphyPen20Regular: CalligraphyPen20Regular, // Writing Assistant
  BotSparkle20Filled: BotSparkle20Filled,
  LightbulbFilament20Regular: LightbulbFilament20Regular,
};

export default iconMapping;
